import { render, staticRenderFns } from "./datasetComparism.vue?vue&type=template&id=68b2ca2e"
import script from "./datasetComparism.vue?vue&type=script&lang=js"
export * from "./datasetComparism.vue?vue&type=script&lang=js"
import style0 from "./datasetComparism.vue?vue&type=style&index=0&id=68b2ca2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports